import React, { useState } from 'react'
import {useDispatch, useSelector} from "react-redux";
import Countries from "../../Countries";

export default function Step2() {
  const dispatch = useDispatch();
  const { currentStep, error, data } = useSelector(state => state.createPersona);
  const [ locations, setLocations ] = useState(data.locations);
  const [ valid, setValidity ] = useState(locations);

  const submit = () => {
    if (locations.length === 0) dispatch({ type: 'SET_ERROR', payload: 'please select country !'});
    else if (!valid) dispatch({ type: 'SET_ERROR', payload: 'please select 3 cities or 1 country or 1 continent !'});
    else {
      dispatch({ type: 'SET_DATA', payload: {...data, locations }});
      dispatch({ type: 'NEXT_STEP', payload: currentStep+1})
    }
  };

  const onLocationChange = (locations) => {
    setLocations(locations);

    const cities = locations.filter(location => location.type === 'city');
    const countries = locations.filter(location => location.type === 'country');
    const regions = locations.filter(location => location.type === 'continent');

    const validCities = cities.length >= 3 && !countries.length && !regions.length;
    const validRegion = regions.length === 1 && !countries.length && !cities.length;
    const validCountry = countries.length === 1 && !regions.length && !cities.length;

    setValidity(validCities || validCountry || validRegion);

  };

  return (
    <>
      {currentStep === 2 && <React.Fragment>
        <p className="title mb-10">Where do your customer reside?</p>

        <p className="mb-30 text-tuna">The better you specify it, the more accurate Lussy generates your personas.</p>

        <div className="mx-auto" style={{ maxWidth: '370px' }}>
          <Countries
            onChange={onLocationChange}
            error={error}
          />

          <input
            type="button"
            onClick={submit}
            className="btn btn--primary col-12 mb-10"
            value="Next"
          />
        </div>
      </React.Fragment>}
    </>
  );

}